<template>
  <AppContainer>
    <div>
      <EPageTitleMobile :title :description />

      <EForm>
        <EFormField id="hazardChecklist" label="" fieldset>
          <template v-for="(item, checkboxIndex) in list" :key="checkboxIndex">
            <ECheckbox
              :id="`checkbox${checkboxIndex}`"
              v-model="model[checkboxIndex].value"
              :name="`checkbox${checkboxIndex}`"
              :label="item.name"
              :value="true"
              :disabled="model[checkboxIndex].disabled"
            />
          </template>
        </EFormField>
      </EForm>
    </div>

    <template #bottom>
      <EButton
        :label="actionLabel"
        :disabled="isActionDisabled"
        block
        @click="emits('actionClick')"
      />
    </template>
  </AppContainer>
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import { EButton, ECheckbox, EForm, EFormField, EPageTitleMobile } from '@expansivefm/eds'
import { computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: false,
    default: '',
  },
  actionLabel: {
    type: String,
    required: true,
  },
  list: {
    type: Array,
    required: true,
  },
})

const emits = defineEmits(['actionClick'])

const model = defineModel({ type: Array, required: true })

const isActionDisabled = computed(() => {
  const shouldBeEnabled = model.value.some((hazard) => {
    if ('value' in hazard) {
      return hazard.value !== null
    }

    return false
  })

  return !shouldBeEnabled
})
</script>
